import { render, staticRenderFns } from "./dataScreening.vue?vue&type=template&id=13e356d8&scoped=true"
import script from "./dataScreening.vue?vue&type=script&lang=js"
export * from "./dataScreening.vue?vue&type=script&lang=js"
import style0 from "./dataScreening.vue?vue&type=style&index=0&id=13e356d8&prod&lang=scss"
import style1 from "./dataScreening.vue?vue&type=style&index=1&id=13e356d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e356d8",
  null
  
)

export default component.exports